module.exports = __webpack_public_path__ + "assets/images/tutorial2.6f9ab4d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial2.png
// module id = 453
// module chunks = 1